import appConfig from '../../appConfig';
import ApplicationAccessCheck from '../../models/AppGallery/CompanyApplication/ApplicationAccessCheck';
import request from '../requestService';

class CompanyApplicationService {
  private readonly BaseUrl = `/CompanyApplication`;

  public async checkApplicationAccess(applicationId: string): Promise<ApplicationAccessCheck> {
    const response = await request.get(`${this.BaseUrl}/CheckApplicationAccess?applicationId=${applicationId}`, {
      baseURL: appConfig.appGalleryBackendUrl,
    });
    return response.data;
  }
}
export default new CompanyApplicationService();
